<template>
  <el-dialog
    :visible="visible"
    @close="$emit('update:visible', false)"
    @closed="initModel()"
    width="800px"
  >
    <div
      slot="title"
      class="Diatitle"
    >
      <span>{{title}}</span>
    </div>
    <el-form
      :model="deviceModel"
      ref="form"
      :rules="rules"
      label-width="100px"
      :inline="true"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="电池编号:"
            prop="bmsNo"
          >
            <el-input
              size="small"
              v-model.trim="deviceModel.bmsNo"
              autocomplete="off"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="电池类型"
            prop="bmsType"
          >
            <el-select
              v-model="deviceModel.bmsType"
              placeholder="请选择"
            >
              <el-option
                v-for="item in bmsTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- <el-autocomplete
              class="inline-input"
              v-model="deviceModel.bmsType"
              :fetch-suggestions="querySearch"
              placeholder="请输入内容"
              clearable
            ></el-autocomplete> -->
            <!-- <el-input
              placeholder="请输入内容"
              v-model="deviceModel.bmsType"
            >
              <el-popover
                slot="suffix"
                placement="bottom"
                trigger="click"
              >
                <div style="padding:5px">
                  <div
                    class="selectBms"
                    v-for="(item, index) in bmsTypeOptions"
                    :key="index"
                    @click="setBms(item.value)"
                  >{{item.value}}</div>
                </div>
                <i
                  slot="reference"
                  :class="['el-input__icon','el-icon-arrow-down']"
                />
              </el-popover>
            </el-input> -->
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="设备号:"
            prop="terminalNo"
          >
            <el-input
              size="small"
              v-model.trim="deviceModel.terminalNo"
              autocomplete="off"
              maxlength="13"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="所属组织:"
            prop="organization"
          >
            <TreeSelect
              v-model="deviceModel.organization"
              :data="treeData"
              :props="defaultProps"
              node-key="organizationId"
              icon="icon-truckgroup"
              :disabled="type === 'update'?true:false"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <template >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="安装时间:"
              prop="doDate"
            >
              <el-date-picker
                v-model="deviceModel.doDate"
                type="datetime"
                placeholder="选择日期时间"
                default-time="00:00:00"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="SIM卡号:"
              prop="sim"
            >
              <el-input
                size="small"
                v-model.trim="deviceModel.sim"
                autocomplete="off"
                maxlength="13"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              label="备注信息:"
              prop="installRemark"
            >
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="deviceModel.installRemark"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template v-if="USER.mostParentId == 63">
        <el-row>
            <el-col>
                <el-form-item label="地址:" prop="address">
                    <el-form label="地址" :label-width="'100px'">
                        <el-select v-model="provinceName" placeholder="请选择省" class="address_select" @change="getsheng"   style="width:186px;margin-right:11px;">
                            <el-option v-for="item in sheng" :key="item.code" :label="item.name" :value="item.code">
                            </el-option>
                        </el-select>
                        <el-select v-model="cityName" placeholder="请选择市" class="address_select" @change="getcity"   style="width:186px;margin-right:11px;">
                            <el-option v-for="item in shi" :key="item.code" :label="item.name" :value="item.code">
                            </el-option>
                        </el-select>
                        <el-select v-model="countyName" placeholder="请选择区" class="address_select" @change="getarea"  style="width:186px;">
                            <el-option v-for="item in qu" :key="item.code" :label="item.name" :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form>
                </el-form-item>
            </el-col>
        </el-row>
      </template>
    </el-form>
    <template slot="footer">
      <el-button
        type="primary"
        plain
        size="small"
        @click="addVehicle"
      >确定</el-button>
      <el-button
        type="info"
        plain
        size="small"
        @click="$emit('update:visible', false)"
      >取消</el-button>
    </template>
  </el-dialog>
</template>

<script>
import day from "dayjs";
import { mapState, mapMutations } from "vuex";
import { toTreeData } from "@/assets/js/base";
import TreeSelect from "@/components/TreeSelect/index.vue";

const defaultDeviceModel = {
  organization: null,
  activationTme: null,
  bmsNo: null,
  bmsType: "三元锂电池",
  doDate: day(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  groupId: null,
  installRemark: null,
  serviceCode: null,
  sim: null,
  terminalNo: null,
  terminalType: "GPRS-XINGHENG",
};

export default {
  components: {
    TreeSelect,
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      flag: true,
      textarea: "",
      value: "",
      address:[],
      sheng: [],
      shi: [],
      qu: [],
      provinceCode:'',
      provinceName:'',
      cityCode:'',
      cityName:'',
      countyCode:'',
      countyName:'',
      terminalTypeOptions: [
        // {
        //   value: "GPRS-部标",
        //   label: "GPRS-部标"
        // },
        {
          value: "GPRS-XINGHENG",
          label: "GPRS-XINGHENG"
        },
        {
          value: "GPRS-BETTER",
          label: "GPRS-BETTER"
        },
        {
          value: "GPRS-PEICHENG",
          label: "GPRS-PEICHENG"
        },
        {
          value: "GPRS-DALI",
          label: "GPRS-DALI"
        },
        {
          value: "GPRS-HERCULES",
          label: "GPRS-HERCULES"
        },
        {
          value: "LD-01A",
          label: "LD-01A"
        },
        {
          value: "GPRS-SUNWODA",
          label: "GPRS-SUNWODA"
        }
      ],
      bmsTypeOptions: [
        {
          value: "三元锂电池",
          label: "三元锂电池"
        },
        {
          value: "磷酸铁锂电池",
          label: "磷酸铁锂电池"
        },
        {
          value: "锰酸锂电池",
          label: "锰酸锂电池"
        }
      ],
      deviceModel: {
        ...JSON.parse(JSON.stringify(defaultDeviceModel))
      },
      rules: {
        bmsNo: [
          {
            required: true,
            message: "电池编号不能为空",
            trigger: "blur"
          },
          // {
          //   pattern: /^[0-9,a-z,A-Z]{6,30}$/,
          //   message: "电池编号不能小于6位",
          //   trigger: "blur"
          // }
        ],
        terminalNo: [
          {
            required: true,
            message: "设备号不能为空",
            trigger: "blur"
          },
          {
            pattern: /^\d{11,13}$/,
            message: "设备号为11-13位",
            trigger: "blur"
          }
        ],
        sim: [
          {
            required: true,
            message: "sim卡号不能为空",
            trigger: "blur"
          },
          {
            pattern: /\d/,
            message: "请输入正确的SIM卡号",
            trigger: "blur"
          }
          // {
          //   pattern: /^1[3-9][0-9]\d{8}$/,
          //   message: "请输入正确的SIM卡号",
          //   trigger: "blur"
          // }
        ],
        // serviceCode: [
        //   {
        //     required: true,
        //     message: "服务密码不能为空",
        //     trigger: "blur"
        //   }
        // ],
        // activationTme: [
        //   {
        //     trigger: "blur",
        //     validator: (rule, value, callback) => {
        //       if (value != null) {
        //         day(value).valueOf() > Date.now()
        //           ? callback(new Error("不能大于当前日期"))
        //           : callback();
        //       }
        //       callback();
        //     }
        //   }
        // ],
        doDate: [
          // {
          //   required: true,
          //   message: "安装日期不能为空",
          //   trigger: "blur"
          // },
          {
            trigger: "blur",
            validator: (rule, value, callback) =>
              day(value).valueOf() > Date.now()
                ? callback(new Error("不能大于当前日期"))
                : callback()
          }
          // {
          //   trigger: "blur",
          //   validator: (rule, value, callback) => {
          //     if (this.deviceModel.activationTme != null) {
          //       day(value).valueOf() > this.deviceModel.activationTme
          //         ? callback(new Error("不能大于激活日期"))
          //         : callback();
          //     }
          //     callback();
          //   }
          // }
        ],
        bmsType: [
          {
            required: true,
            message: "请选择电池类型",
            trigger: "blur"
          }
        ],
        terminalType: [
          {
            required: true,
            message: "请选择设备类型",
            trigger: "blur"
          }
        ],
        organization: [
          {
            required: true,
            message: "所属组织不能为空", //this.$t("login.username_rules"),
            trigger: "blur"
          },
          { type: "object", message: "所属组织不能为空" }
        ]
      },
      defaultProps: {
        children: "children",
        label: "organizationName"
      }
    };
  },

  computed: {
    ...mapState(["GROUPLIST","USER"]),
    treeData() {
      return toTreeData(this.GROUPLIST, {
        id: "organizationId",
        parentId: "parentId"
      });
    },
    title() {
        const titleObj = {
            add: "添加设备",
            update: "修改设备"
        };

      return titleObj[this.type];
    }
  },
  watch: {
    params: {
      handler(val) {
        if (!val) return;
        this.deviceModel = val;
        const { groupId, groupName, ...otherParams } = val;
        const organizationId = val.groupId || val.organizationId,
        organizationName = val.groupName || val.organizationName;
        this.deviceModel.organization = { organizationId, organizationName };

        if(!this.deviceModel.provinceCode){
            this.provinceName = '';
            this.cityName = '';
            this.countyName = '';
        }else{
            console.log(this.deviceModel.provinceCode)
            this.provinceCode=this.deviceModel.provinceCode;
            this.cityCode=this.deviceModel.cityCode;
            this.countyCode=this.deviceModel.countyCode;
            this.sheng = this.address.map(item=>{
                return {
                    code:item.code,
                    id:item.id,
                    name:item.name
                };
            })
            this.address.map(item=>{
                if(item.code == this.deviceModel.provinceCode){
                    this.provinceName = item.name;
                    this.shi = item.list;
                    item.list.map(keys=>{if(keys.code == this.deviceModel.cityCode){
                        this.cityName = keys.name;
                        this.qu = keys.list;
                        keys.list.map(val=>{if(val.code == this.deviceModel.countyCode){
                            this.countyName = val.name;
                        }})
                    }})
                }
            })
        }
        Object.keys(this.deviceModel).map(
          key =>
            otherParams[key] !== undefined &&
            (this.deviceModel[key] = otherParams[key])
        );
      }
    },
    title:{
        handler(val){
            this.address = this.$store.state.addressArr;
            this.provinceCode=this.deviceModel.provinceCode || '';
            this.cityCode=this.deviceModel.cityCode || '';
            this.countyCode=this.deviceModel.countyCode || '';
            this.sheng = this.address.map(item=>{
                return {
                    code:item.code,
                    id:item.id,
                    name:item.name
                };
            })
            this.address.map(item=>{
                if(item.code == this.provinceCode){
                    this.provinceName = item.name;
                    this.shi = item.list;
                    item.list.map(keys=>{if(keys.code == this.cityCode){
                        this.cityName = keys.name;
                        this.qu = keys.list;
                        keys.list.map(val=>{if(val.code == this.countyCode){
                            this.countyName = val.name;
                        }})
                    }})
                }
            })
            console.log(this.provinceCode)
            if(!this.provinceCode){
                this.provinceName = '';
                this.cityName = '';
                this.countyName = '';
            }
        }
    }
  },
  methods: {
    handleApi() {},
    //添加地址
    AssigCode(data){
        this.provinceCode = data.provinceCode;
        this.cityCode = data.cityCode;
        this.countyCode = data.countyCode;
    },
    // 获取省
    getsheng(id) {
        this.address.filter(item=>{
            if(item.code == id){
                this.shi = item.list;
                this.provinceCode = item.code;
            };
        })
        this.cityName = this.shi[0].name;
        this.getcity(this.shi[0].code);
    },
    // 点击地区获取市
    getcity(id) {
        this.shi.filter(item=>{
            if(item.code == id){
                this.qu = item.list;
                this.cityCode = item.code;
                this.getarea(this.qu[0].code);
            };
        })
        this.countyName = this.qu[0].name;
    },
    // 点击城市获取区
    getarea(id) {
        this.qu.filter(item=>{
            if(item.code == id){
                this.countyCode = item.code;
            }
        })
        let data = {
            provinceCode:this.provinceCode,
            cityCode:this.cityCode,
            countyCode:this.countyCode,
        }
        this.$emit('AssigCode',data);
    },
    ...mapMutations(["COMMIT_GROUPLIST"]),
    initModel() {
      this.provinceName = '';
      this.cityName = '';
      this.countyName = '';
      this.$refs.form.resetFields();
      this.deviceModel = JSON.parse(JSON.stringify(defaultDeviceModel));
    },
    // querySearch(queryString, cb) {
    //   var restaurants = this.bmsTypeOptions;
    //   var results = queryString
    //     ? restaurants.filter(this.createFilter(queryString))
    //     : restaurants;
    //   // 调用 callback 返回建议列表的数据
    //   cb(results);
    // },
    // createFilter(queryString) {
    //   return restaurant => {
    //     return (
    //       restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
    //       0
    //     );
    //   };
    // },
    setBms(data) {
      this.deviceModel.bmsType = data;
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y, M, D, h, m, s;
      Y = date.getFullYear() + "-";
      M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      D = date.getDate() + " ";
      h = date.getHours() + ":";
      m = date.getMinutes() + ":";
      s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    async add(_params) {
      const params = {
        ..._params
      };
      params.groupId = this.deviceModel.organization.organizationId;

      delete params.activationTme;
      return await this.$API.addVehicle(params);
    },
    async update(_params) {
      const { vehicleId } = this.params;
      const params = {
        ..._params,
        vehicleId
      };
      params.expireDate = day(params.activationTme).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      return await this.$API.updateVehicle(params);
    },
    async addVehicle() {
      try {
        await this.$refs.form.validate();
        this.deviceModel.doDate = day(this.deviceModel.doDate).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        if(this.USER.mostParentId == 63){
            this.deviceModel.provinceCode = this.provinceCode
            this.deviceModel.cityCode = this.cityCode
            this.deviceModel.countyCode = this.countyCode
        }
        const params = this.deviceModel;
        const apiFnObj = {
          add: "add",
          update: "update"
        };

        const { msg } = await this[apiFnObj[this.type]](params);
        this.$msg({
          showClose: true,
          message: msg,
          type: "success"
        });

        this.$emit("update:visible", false);
        this.$emit("onHandleDeviceOk");

        //更新树状图
        const { data } = await this.$API.getOTree();
        if (Array.isArray(data)) {
          this.COMMIT_GROUPLIST(data);
        } else {
          this.COMMIT_GROUPLIST([data]);
        }
      } catch (error) {
        console.error(error);
        this.$msg({
          showClose: true,
          message: error ? error.msg : "请输入正确字段",
          type: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-select,
.el-input,
.el-date-editor,
.el-autocomplete {
  width: 200px !important;
}
.el-textarea {
  width: 580px !important;
}
// .w140{
//   width: 140px !important;
// }
// .w120{
//   width: 120px !important;
// }
// .w160{
//   width: 160px !important;
// }
// .w80{
//   width: 80px !important;
// }
.selectBms {
  padding: 5px 0;
  cursor: pointer;
  font-weight: bold;
  color: rgb(115, 177, 177);
}
.selectBms:hover {
  background-color: rgb(218, 219, 219);
}
::v-deep .el-dialog__headerbtn {
  top: 12px !important;
}
.Diatitle {
  width: 100%;
  height: 42px;
  background-color: #f6f6f6;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  span {
    padding: 0 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}
</style>
